module.exports = "<div class=s-loading> <spinner></spinner> <p>Loading</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/page/views/loading.html
// module id = 755
// module chunks = 0